import React, { Fragment } from 'react'
import { translate } from '../Services/translation'
import MiniCartOrderRow from './MiniCartOrderRow'

const getOrderRowElements = (
    orderRows,
    removeOrderRow,
    updateOrderRowQuantity
) => {
    const orderRowElements = orderRows.map(
        (row) =>
            !row.isHidden && (
                <MiniCartOrderRow
                    orderRow={row}
                    removeOrderRow={removeOrderRow}
                    updateOrderRowQuantity={updateOrderRowQuantity}
                    key={row.rowSystemId}
                />
            )
    )
    return <div className="cart__info-order-rows">{orderRowElements}</div>
}

const getCartContent = (
    orderRows,
    quantity,
    orderTotal,
    checkoutUrl,
    removeOrderRow,
    updateOrderRowQuantity
) => {
    if (quantity === '0') {
        return (
            <span className="cart__info-empty-text">
                {translate('minicart.empty')}
            </span>
        )
    } else {
        const rowCount = orderRows.length
        return (
            <Fragment>
                {getOrderRowElements(
                    orderRows,
                    removeOrderRow,
                    updateOrderRowQuantity
                )}
                <p className="cart__info-row cart__info-row--summary">
                    <span>
                        {quantity} {translate('minicart.numberofproduct')}
                    </span>
                    <span>
                        {' '}
                        <b>{translate('minicart.total')}</b> {orderTotal}
                    </span>
                </p>
                <p className="cart__info-row">
                    <a href={checkoutUrl} className="cart__checkout-button">
                        <i className="icon-tire"></i>
                        {translate('minicart.checkout')}
                    </a>
                </p>
            </Fragment>
        )
    }
}

const getVisibleQuantity = (orderRows) => {
    var quantity = 0
    orderRows.forEach((row) => {
        if (!row.isHidden) {
            quantity += row.quantity
        }
    })
    return quantity
}

const MiniCart = ({
    quantity,
    orderTotal,
    orderRows,
    checkoutUrl,
    showInfo,
    toggle,
    removeOrderRow,
    updateOrderRowQuantity,
}) => (
    <Fragment>
        <a
            href={checkoutUrl}
            className={`cart__link--block ${
                !checkoutUrl ? 'cart__cursor-default' : ''
            }`}
            title={translate('minicart.title')}
        >
            <i className="cart__icon icon-tire">
                <span className="cart__quantity">
                    {getVisibleQuantity(orderRows)}
                </span>
            </i>
            <span className="cart__title show-for-large">
                {translate('minicart.title')}
            </span>
        </a>
        <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
            <span
                className="cart__close-button fa fa-times"
                onClick={() => toggle()}
            ></span>
            {getCartContent(
                orderRows,
                quantity,
                orderTotal,
                checkoutUrl,
                removeOrderRow,
                updateOrderRowQuantity
            )}
        </div>
    </Fragment>
)

export default MiniCart
